import { cn } from '@/utils/cn';
import { InlineMessage } from './inline-message';
import { TextFieldProps } from './types';
import { IconInfoCircle } from '../icons';
import Tooltip from '../tooltip';
export const TextField = ({
  name,
  title,
  tooltip,
  inputSize,
  direction = 'rtl',
  inlineMessage,
  rightIcon,
  leftIcon,
  secondLeftIcon,
  id,
  placeholder,
  disabled = false,
  isTextArea = false,
  registeredField,
  className,
  fillInlineMessageSpace = false,
  onChange,
  autoComplete = 'off',
  value,
  onBlur,
  spaceBottomStyle,
  onKeyDown,
  defaultValue,
  required,
  tabIndex,
  autoFocus,
  type = 'text',
  inputMode,
  normalize,
  maxLength,
  isLoading,
  inputClassName,
  toolparamdescription
}: TextFieldProps) => {
  const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (normalize) {
      event.target.value = normalize(event.target.value);
    }
    registeredField?.onChange(event);
    onChange?.(event);
  };
  const extractedRegisteredField = {
    ...registeredField,
    onChange: changeHandler
  };
  const withTooltip = typeof tooltip !== 'undefined';
  return <div className={cn('relative flex flex-col gap-1 text-body-14 lg:text-body-16', className)} data-sentry-component="TextField" data-sentry-source-file="text-field.tsx">
            {!!title && <label htmlFor={id} className={withTooltip ? 'relative flex items-center gap-1' : ''}>
                    {title}{' '}
                    {withTooltip && <Tooltip className={cn('h-fit w-full', tooltip.className)} position='top' tooltipText={tooltip.title} hasIcon={true}>
                            <IconInfoCircle className='h-5 w-5 text-alert-info-dark' />
                        </Tooltip>}
                </label>}

            {isLoading ? <div className='h-11 w-full animate-pulse rounded bg-gray-100' /> : <div className={cn('flex items-center gap-2 [&>svg]:w-6 [&>svg]:shrink-0', 'rounded border', {
      'px-2 py-[9px]': inputSize === 'large',
      'px-2 py-[7px]': inputSize !== 'large',
      'border-border-gray-medium bg-surface-solid-50 text-text-mediumGray [&>svg]:text-text-lightGray': disabled,
      'border-border-gray-medium bg-surface-solid-0 focus-within:border-border-pink [&>svg]:text-text-darkGray': inlineMessage?.message && inlineMessage?.type !== 'error' && !disabled,
      'border-alert-error-dark focus-within:border-alert-error-dark': inlineMessage?.message && inlineMessage?.type === 'error'
    }, inputClassName)}>
                    {rightIcon}

                    {isTextArea ? <textarea name={name} id={id} className='disabled:placeholder-text-lighGray w-full overflow-hidden bg-transparent focus-within:outline-none enabled:placeholder-text-mediumGray disabled:bg-transparent' dir={direction} placeholder={placeholder} disabled={disabled} defaultValue={defaultValue} rows={3} required={required} tabIndex={tabIndex} autoFocus={autoFocus} toolparamdescription={toolparamdescription} {...registeredField} /> : <input type={type} name={name} id={id} value={value} className='disabled:placeholder-text-lighGray w-full overflow-hidden bg-transparent focus-within:outline-none enabled:placeholder-text-mediumGray disabled:bg-transparent' dir={direction} placeholder={placeholder} disabled={disabled} onBlur={onBlur} onKeyDown={onKeyDown} autoComplete={autoComplete} defaultValue={defaultValue} required={required} tabIndex={tabIndex} autoFocus={autoFocus} inputMode={inputMode} maxLength={maxLength} toolparamdescription={toolparamdescription} {...extractedRegisteredField} />}
                    {secondLeftIcon}

                    {leftIcon}
                </div>}

            {inlineMessage?.message ? <InlineMessage {...inlineMessage} /> : !fillInlineMessageSpace && <div className={cn('h-5 w-full', spaceBottomStyle)} />}
        </div>;
};